export const env = {
    apiUrl: 'https://admin.mmcmyanmarmotor.com/api/',
    imageUrl: 'https://admin.mmcmyanmarmotor.com',
    siteUrl: 'https://mmcmyanmarmotor.com',
}